import React from 'react';

import './index.css';
import logoSrc from './img/logo.png';
import LazyLoad from 'react-lazyload'; // Import LazyLoad


function Sales() {
  return (
    <>
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title" id='titulli'>drive sales with Shigjeta</h1>
            <p className="banner-description">
              Maximize your revenue and market reach with Shigjeta’s proven sales generation strategies. From lead
              generation to regional chambers representing us globally, we ensure your business reaches its full
              potential.
            </p>
            <a href="/become-agent" className="banner-button">Start Generating Sales</a>
          </div>
     
        </div>
      </section>
      <div className='video-background'>
      <LazyLoad height={400} offset={100}>

      <video
              className="video"
              id='banner1-video'
              src="/video/ARROW SALES.mp4"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
            />

            </LazyLoad>
      </div>
      {/* Section 1: Our Sales Services */}
      <section className="about-section">
      <div className="about-row">
  <div className="about-text">
    <h2><strong>Comprehensive Sales Solutions</strong></h2>
    <p>
      At Shigjeta, we provide tailor-made sales solutions designed to deliver measurable results. Whether it’s
      identifying leads, managing client outreach, or enhancing conversions, we’re here to boost your business.
    </p>
    <div className="services-grid">
      <div className="service">
        <p><strong>Lead Generation:</strong> Find high-potential clients tailored to your goals.</p>
      </div>
      <div className="service">
        <p><strong>Outbound Telemarketing:</strong> Target new customers and expand your market.</p>
      </div>
      <div className="service">
        <p><strong>Inbound Services:</strong> Handle customer support, inquiries, and follow-ups.</p>
      </div>
      <div className="service">
        <p><strong>Sales Consulting:</strong> Custom strategies to optimize sales processes.</p>
      </div>
    </div>
    <a href='/become-agent' className="cta-button">Explore Our Sales Services</a>
  </div>
  <div className="about-image">
    <img src="img/pg3.1.png" alt="Our Sales Services" />
  </div>
</div>

        {/* Section 2: Chambers of Shigjeta */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Global Representation Through Our Chambers</strong></h2>
            <p>
              Shigjeta’s Chambers operate like embassies, representing our company in key regions worldwide. These
              chambers not only delegate and advocate for us but also provide insights on market trends, legal
              frameworks, and opportunities to connect with high-class clients. Their role is vital in expanding our
              global reach and securing strategic collaborations.
            </p>
            <ul>
              <p><strong>Represent Shigjeta and advocate for us globally.</strong></p>
              <p><strong>Provide market intelligence on trends and opportunities.</strong></p>
              <p><strong>Facilitate connections with high-profile clients and partners.</strong></p>
              <p><strong>Support negotiations and partnerships across borders.</strong></p>
            </ul>
            <a href='/chambers-shigjeta' className="cta-button">Explore Our Global Chambers</a>
          </div>
          <div className="about-image">
            <img src="img/pg3.2.png" alt="Chambers of Shigjeta" />
          </div>
        </div>

        {/* Section 3: Become a Sales Agent */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Join Our Sales Force</strong></h2>
            <p>
              Looking to earn while working flexibly? As a Sales Agent, you’ll represent Shigjeta’s services, close
              deals, and earn commissions for every successful sale. This is a perfect opportunity for motivated
              individuals looking to grow their income while collaborating with an innovative company.
            </p>
            <ul>
              <p><strong>High commission rates</strong> on every closed deal.</p>
              <p><strong>Resources</strong> for effective sales.</p>
              <p><strong>Flexible, results-driven work environment.</strong></p>
            </ul>
            <a href='/become-agent' className="cta-button">Apply as a Sales Agent</a>
          </div>
          <div className="about-image">
            <img src="img/pg3.3.png" alt="Become a Sales Agent" />
          </div>
        </div>

        {/* Section 4: Case Studies & Results */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Proven Results Across Markets</strong></h2>
            <p>
              With Shigjeta, sales aren’t just numbers—they’re transformative growth stories. From successful
              campaigns to record-breaking lead conversions, discover how businesses have partnered with us to
              achieve exceptional results.
            </p>
            <a href='blog' className="cta-button">Read Success Stories</a>
          </div>
          <div className="about-image">
            <img src="img/pg3.4.png" alt="Sales Case Studies" />
          </div>
        </div>
      </section>
    </>
  );
}

export default Sales;
